import { AuthN, getConfig } from '@seek/online-identity';

export default (): AuthN =>
  new AuthN(getConfig('seekAnz-candidate', window.location));
